/* ============================================================
   LUSSÈCO FOUNDATION JS — scroll reveals + quick add
   Upload to: Assets. Loaded (deferred) by every lusseco-* section.
   Guarded against double-init when multiple sections load it.
   ============================================================ */
(function () {
  if (window.LussecoFoundation) return;
  window.LussecoFoundation = true;

  /* ---- Scroll reveals: fade + rise, staggered 100ms, trigger once ---- */
  function initReveals(scope) {
    var els = (scope || document).querySelectorAll('.lus-reveal:not(.lus-in)');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lus-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var parent = e.target.parentElement;
        var sibs = parent ? Array.prototype.filter.call(parent.children, function (c) {
          return c.classList && c.classList.contains('lus-reveal');
        }) : [e.target];
        var i = Math.max(0, sibs.indexOf(e.target));
        e.target.style.transitionDelay = (i * 100) + 'ms';
        e.target.classList.add('lus-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Quick add (single-variant products only) ----
     Adds via /cart/add.js, then refreshes Dawn's cart drawer +
     icon bubble via the Section Rendering API. Falls back to /cart. */
  function initQuickAdd(scope) {
    (scope || document).querySelectorAll('[data-lus-quick-add]:not([data-lus-bound])').forEach(function (btn) {
      btn.setAttribute('data-lus-bound', '1');
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var id = btn.getAttribute('data-lus-quick-add');
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-lus-adding-text') || 'Adding…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: 1, sections: 'cart-drawer,cart-icon-bubble' })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (data) {
            var drawer = document.querySelector('cart-drawer');
            if (data.sections && drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents({ sections: data.sections, id: data.id });
            } else if (data.sections) {
              ['cart-drawer', 'cart-icon-bubble'].forEach(function (key) {
                var target = document.getElementById(key === 'cart-drawer' ? 'CartDrawer' : 'cart-icon-bubble');
                if (target && data.sections[key]) {
                  var doc = new DOMParser().parseFromString(data.sections[key], 'text/html');
                  var fresh = doc.getElementById(key === 'cart-drawer' ? 'CartDrawer' : 'cart-icon-bubble');
                  if (fresh) target.innerHTML = fresh.innerHTML;
                }
              });
              var d = document.querySelector('cart-drawer');
              if (d && typeof d.open === 'function') d.open();
            } else {
              window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
            }
            btn.textContent = btn.getAttribute('data-lus-added-text') || 'Added';
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
          })
          .catch(function () {
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          });
      });
    });
  }

  function initAll() { initReveals(document); initQuickAdd(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }

  /* Re-init inside the theme customizer when sections load/reorder */
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target); initQuickAdd(e.target);
  });
})();
